import React from 'react';
import { Map, Marker } from 'google-maps-react';

const GoogleMap = ({ markers, ...rest }) => {
  return (
    <Map {...rest} google={window.google}>
      {markers.map(({ lat, lng }, index) => (
        <Marker key={index} position={{ lat, lng }} />
      ))}
    </Map>
  );
};

export default GoogleMap;
